// import { getFormattedImageLink } from "../../../../Utils";
import { Tooltip } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Add from "@material-ui/icons/Add";
import cancelIcon from "Assets/Svg/cancel.svg";
import Thumbnail from "Component/Thumbnail/ThumbnailSmall";
import Configs from "Constants/Configs";
import get from "lodash/get";
import React from "react";
import Dropzone from "react-dropzone";
import { FormattedMessage } from "react-intl";
import { instance, instanceMultipart } from "../../../../Actions/AxiosInstance";
import addressEmployee from "../../../../Assets/Images/education.svg";
import documentIcon from "../../../../Assets/Svg/document-icon.svg";
import If from "../../../../Component/Common/If";
import { getUrlExtension } from "../../../../Handlers/getters";
import createstore from "../../../../store";
import CreateComp from "../create";
import { NoRecordFound } from "../EmpMainProfile/NoRecordFound";

class OtherDocuments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      datareceived: true,
      showform: false,
      isShuffle: false,
      documentname: "",
      errordocumentname: false,
      documentimage: "",
      activities: null,
      hideButton: false,
      isbuttonDisabled: false,
      flag: 0,
      employeefileid: "",
      showBtfalsen: false,
      selectedUploadDoc: "",
      selectedDoc: "",
      selectedDocType: "",
      EmpDocsReceived: [],
    };
    this.onEditClicked = this.onEditClicked.bind(this);
    this.uploadDoc = this.uploadDoc.bind(this);
    this.removeFile = this.removeFile.bind(this);
    this.getEmpDocs = this.getEmpDocs.bind(this);
    this.removeImage = this.removeImage.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  componentDidMount() {
    // this.GetEducationGrade();
    const { SubscriptionInfo } = createstore.getState();
    const { accountid } = SubscriptionInfo.SubscriptionData;
    const { subscriptionid } = SubscriptionInfo.SubscriptionData;
    const { countrytimezoneid } = SubscriptionInfo.SubscriptionData;
    this.getFormattedImageLink = this.getFormattedImageLink.bind(this);
    // let employeeid = SubscriptionInfo.SubscriptionData.employeeid;
    const DateFormat = get(
      SubscriptionInfo,
      "SubscriptionData.dateformatname",
      "",
    );
    let ShortDateFormat =
      typeof DateFormat === "string" ? DateFormat.split(" ") : [""];
    ShortDateFormat = ShortDateFormat[0];
    let employeeid;
    employeeid = SubscriptionInfo.SubscriptionData.employeeid;

    const { AuthenticationAction } = createstore.getState();
    if (AuthenticationAction.IsFulfilled) {
      employeeid = AuthenticationAction.login.employeeid;
    }
    const { colleagueid } = this.props.match.params;
    const masterprofileid = get(
      AuthenticationAction,
      "login.masterprofileid",
      9,
    );
    const { permissions } = this.props;
    let hideButton;
    permissions.editable
      ? colleagueid && colleagueid != employeeid
        ? masterprofileid != 9
          ? (hideButton = true)
          : (hideButton = false)
        : (hideButton = false)
      : masterprofileid != 9
      ? (hideButton = true)
      : (hideButton = false);

    this.setState({
      accountid,
      subscriptionid,
      countrytimezoneid,
      employeeid,
      ShortDateFormat,
      colleagueid,
      hideButton,
    });
    this.getEmpDocs();
  }

  getFormattedImageLink(link) {
    const ext1 = getUrlExtension(link);
    // const ext1 = ext || getUrlExtension(docUrl);
    switch (ext1) {
      case "jpg":
      case "jpeg":
      case "png":
        return `${Configs.STORE_URL}${link}`;
      case "pdf":
      case "ppt":
      case "pptx":
      case "doc":
      case "docx":
      case "txt":
      case "text":
      case "rtf":
      case "odt":
        return documentIcon;
      default:
        return null;
    }
  }

  onSave = () => {
    const { selectedUploadDoc, selectedDocType } = this.state;
    const fileMetaData = selectedUploadDoc;
    if (!fileMetaData) {
      this.props.enqueueSnackbar("Please select a file to upload", {
        variant: "error",
      });
    }
    if (!selectedDocType) {
      this.props.enqueueSnackbar("Please enter the name of the document", {
        variant: "error",
      });
    }
    const filename = this.state.selectedDocType;
    let fileid;
    if (!this.state.employeefileid) {
      // fileid =
      //   get(this.props, "colleagueid", "") ||
      //   get(
      //     this.state.employeefileid,
      //     "AuthenticationAction.login.employeeid",
      //     null,
      //   );
      fileid = null;
    } else {
      fileid = this.state.employeefileid;
    }
    let originalfilename;
    if (fileMetaData) {
      if (fileMetaData.originalfilename) {
        originalfilename = fileMetaData.originalfilename;
      } else {
        originalfilename = fileMetaData.originalname;
      }
    }
    let imagedata = [];
    if (this.state.selectedUploadDoc.uuid === 1) {
      imagedata = null;
    } else {
      imagedata.push(this.state.selectedUploadDoc);
    }
    let documentid;
    if (fileMetaData.documentid) {
      documentid = fileMetaData.documentid;
    } else {
      documentid = null;
    }
    console.log(selectedUploadDoc);
    if (selectedDocType && selectedUploadDoc) {
      const data = {
        employeeid:
          get(this.props, "colleagueid", "") ||
          get(this.props, "AuthenticationAction.login.employeeid", ""),
        filedata: {
          filedata: [
            {
              employeefileid: fileid,
              filename,
              originalfilename,
              fileextension: fileMetaData.extension,
              filesize: fileMetaData.size,
              filepath: fileMetaData.imagepath,
              filetagtypeid: 99,
              filefortypeid: 1,
            },
          ],
        },
        imagedata,
        documentid,
      };
      instance.post("employee/insertupdateemployeefile", data).then((resp) => {
        this.setState(
          { selectedDocType: "", selectedUploadDoc: "", drawerStatus: false },
          () => this.getEmpDocs(),
        );
      });
    }
  };

  getIntroComponent() {
    const { hideButton } = this.state;
    return (
      <div>
        <Grid container>
          <Grid item xs={12} md={12} sm={12} className="margin-left-24">
            {!hideButton ? (
              <CreateComp
                text="Start by uploading some of your personal documents"
                heading="Other Documents"
                onCreate={this._onCreate}
                imageSrc={addressEmployee}
              />
            ) : (
              <NoRecordFound />
            )}
          </Grid>
        </Grid>
      </div>
    );
  }

  UpdateData(name, e) {
    // console.log('e: ', e.target.value);
    this.setState({ selectedDocType: e.target.value });
    console.log("selectedDocType: ", this.state.selectedDocType);
    if (e.target.value == "") {
      this.setState({
        errordocumentname: true,
      });
    } else {
      this.setState({
        errordocumentname: false,
      });
    }
  }

  _onCreate = () => {
    // this.SetFlag(2);
    this.setState({ flag: 2 });
  };

  onEditClicked(doc) {
    if (doc.filesize) {
      const oldFile = doc;
      this.setState({
        flag: 2,
        selectedUploadDoc: {
          originalfilename: oldFile.originalfilename,
          size: oldFile.filesize,
          extension: oldFile.fileextension,
          imagepath: oldFile.filepath,
          uuid: 1,
          documentid: oldFile.documentid,
        },
        employeefileid: oldFile.employeefileid,
        selectedDocType: oldFile.filename,
      });
    } else {
      this.setState({
        flag: 2,
      });
    }
  }

  removeFile(docDetails) {
    this.props.enqueueSnackbar("Are you sure you want to delete?", {
      variant: "warning",
      action: [
        <Button
          key="1"
          color="inherit"
          size="small"
          onClick={() => {
            const data = {
              employeefileid: [docDetails.employeefileid],
            };
            this.props.closeSnackbar();
            instance
              .post("employee/deleteemployeefile", data)
              .then(() => {
                this.getEmpDocs();
                this.props.enqueueSnackbar("Deleted successfully", {
                  variant: "success",
                });
              })
              .catch((error) => {
                const CommonError = error.response
                  ? error.response.data.error.message
                  : error.message;
                this.props.enqueueSnackbar(CommonError, { variant: "error" });
              });
          }}
        >
          Yes
        </Button>,
        <Button
          key="2"
          color="inherit"
          size="small"
          onClick={() =>
            this.setState({ createmenu: false }, () =>
              this.props.closeSnackbar(),
            )
          }
        >
          No
        </Button>,
      ],
    });
  }

  getViewComponent() {
    const { hideButton } = this.state;
    return (
      <div>
        {this.state.EmpDocsReceived.map((item, index) => (
          <div key={index}>
            <Grid container className="margin-top-16">
              <Grid md={6} xs={12}>
                <div className="address-data small-dark-secondary t-bold">
                  {/* <span><FormattedMessage id="LbCompanyName" defaultMessage="Company Name" /></span><br /> */}
                  {item !== "" ? item.filename : ""}
                </div>
                <Thumbnail
                  className="margin-top-8"
                  canDelete={false}
                  key="i"
                  doc={{ url: item.filepath }}
                />
              </Grid>
              <Grid md={6} xs={12}>
                <If condition={!hideButton}>
                  <div className="position-rel">
                    <svg
                      className={
                        this.state.hideButton
                          ? "hide-button"
                          : "address-edit cursour-pointer"
                      }
                      onClick={() => this.onEditClicked(item)}
                      width="24"
                      style={{ marginRight: 40 }}
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM5.92 19H5v-.92l9.06-9.06.92.92L5.92 19zM20.71 5.63l-2.34-2.34c-.2-.2-.45-.29-.71-.29s-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41z" />
                    </svg>
                    <svg
                      className={
                        this.state.hideButton
                          ? "hide-button"
                          : "address-edit cursour-pointer"
                      }
                      onClick={() => this.removeFile(item)}
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4z" />
                      <path fill="none" d="M0 0h24v24H0V0z" />
                    </svg>
                  </div>
                </If>
              </Grid>
            </Grid>
          </div>
        ))}
        {!hideButton && (
          <div
            tabIndex="6"
            className="margin-top-8"
            onClick={this.onEditClicked}
          >
            <Button
              size="large"
              style={{ background: "#166ab3", color: "white" }}
            >
              <span>
                <FormattedMessage id="LbAddmore" defaultMessage="ADD MORE" />
              </span>
            </Button>
          </div>
        )}
      </div>
    );
  }

  uploadDocEdit = (e) => {
    if (get(e, "target.files[0]", "")) {
      const _file = e.target.files[0];
      this.uploadDoc([_file]);
    }
  };

  getEmpDocs() {
    const URL = "employee/getemployeefile";
    const DATA = {};
    if (this.props.colleagueid) {
      DATA.employeeid = this.props.colleagueid;
    }
    instance
      .post(URL, DATA)
      .then((result) => {
        this.setState({
          EmpDocsReceived: result.data.result,
          received: true,
          selectedDoc: "",
        });
        if (result.data.result.length !== 0) {
          this.setState({ flag: 1 });
        } else {
          this.setState({ flag: 0 });
        }
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  uploadDoc(files) {
    const file = files[0];
    let extFile;
    if (file) {
      const img = file.name.split(";");
      const imgname = img[0];
      extFile = getUrlExtension(imgname);
      // let idxDot;
      // idxDot = imgname.lastIndexOf(".") + 1;
      // extFile = imgname.substr(idxDot, imgname.length).toLowerCase();
    }
    const availableExt = [
      "png",
      "jpg",
      "jpeg",
      "pdf",
      "ppt",
      "pptx",
      "doc",
      "docx",
      "txt",
      "odt",
    ];
    if (availableExt.findIndex((x) => extFile == x) == -1) {
      this.props.enqueueSnackbar("Please upload image or pdf only", {
        variant: "error",
      });
      return;
    }
    const formData = new FormData();
    formData.append("file", file);
    const URL = "employee/uploademployeefiles";
    instanceMultipart.post(URL, formData).then((resp) => {
      const fileMetaData = resp.data.result[0];
      console.log(fileMetaData);
      this.setState({ selectedUploadDoc: fileMetaData });
    });
  }

  removeImage() {
    this.setState({
      selectedUploadDoc: null,
    });
  }

  onCancel() {
    if (this.state.EmpDocsReceived.length !== 0) {
      this.setState({
        flag: 1,
        selectedUploadDoc: "",
        employeefileid: "",
        selectedDocType: "",
      });
    }
  }

  getEditComponent() {
    const {
      DocTypes,
      selectedDocType,
      selectedUploadDoc,
      EmpDocsReceived = [],
    } = this.state;
    return (
      <div className="emp-from-wrapper work-experience">
        <div className="form-height">
          <div className="custom-form-box profile-work-exp">
            <div className="inner-wrapper opaque">
              <div className="form-group">
                <div className="margin-left-1">
                  <p className="input-form-label">
                    <FormattedMessage
                      id="identity section"
                      defaultMessage="Document's Name"
                    />
                  </p>
                  <TextField
                    id="documentName"
                    onChange={this.UpdateData.bind(this, "selectedDocType")}
                    defaultValue={this.state.selectedDocType}
                    margin="dense"
                    variant="outlined"
                    inputProps={{ maxLength: 90 }}
                    tabIndex="2"
                    autoFocus
                  />
                  <div>
                    {this.state.errordocumentname == true ? (
                      <span className="caption-error">
                        <FormattedMessage
                          id="Erdocumentname"
                          defaultMessage="Document's Name"
                        />
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
              <div className="form-group margin-bottom-16">
                {selectedUploadDoc ? (
                  <Grid md="12">
                    {/* <input id="fileupload" type="file" name="Upload Emploxyee Data" onChange={(e) => this.uploadDocEdit(e)} hidden /> */}
                    <div
                      key="img"
                      className="add-attachment"
                      style={{ marginRight: 16 }}
                    >
                      <img
                        src={this.getFormattedImageLink(
                          selectedUploadDoc.imagepath,
                        )}
                        className="expense-attachment-img"
                      />
                      <img
                        src={cancelIcon}
                        className="remove-attachment-icon"
                        style={{ zIndex: 0 }}
                        onClick={this.removeImage}
                      />
                    </div>
                  </Grid>
                ) : (
                  <Grid
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div className="add-attachment drag-drop1">
                      <Tooltip title="Insert attachment" placement="right">
                        <Dropzone
                          onDrop={(e) => this.uploadDoc(e)}
                          multiple={false}
                          accept="image/gif, image/jpeg, image/png, image/jpg, .pdf "
                          maxSize={10485760}
                          className="drag-drop"
                        >
                          <Add className="add-attachement-icon" />
                        </Dropzone>
                      </Tooltip>
                    </div>
                    <p className="input-label">
                    Note:<br></br>
                      Supported files: .gif, .jpeg, .png<br></br>
                      Max size: 10MB
                    </p>
                  </Grid>
                )}
              </div>
              <div className="margin-top-10">
                <span
                  className={this.state.isbuttonDisabled ? "hide-event" : ""}
                  tabIndex="5"
                >
                  <Button
                    variant="contained"
                    size="large"
                    color="primary"
                    className="lifeevent-btn save"
                    onClick={this.onSave}
                  >
                    <span>
                      <FormattedMessage id="BtSave" defaultMessage="SAVE" />
                    </span>
                  </Button>
                </span>
                <span tabIndex="6" className="margin-left-5">
                  <Button
                    size="large"
                    className="lifeevent-btn cancel"
                    onClick={this.onCancel}
                  >
                    <span>
                      <FormattedMessage id="BtCancel" defaultMessage="Cancel" />
                    </span>
                  </Button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { datareceived, flag } = this.state;
    return (
      <div>
        <If condition={datareceived} className={flag == 0 ? "add" : ""}>
          <If condition={flag == 0}>{this.getIntroComponent()}</If>
          <If condition={flag == 1}>{this.getViewComponent()}</If>
          <If condition={flag == 2}>{this.getEditComponent()}</If>
        </If>
      </div>
    );
  }
}

export default OtherDocuments;
